import React from "react";
import Headers from "../../Components/Headers";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import image1 from "../../Assets/image1.jpg";
import image2 from "../../Assets/image2.jpeg";
import image3 from "../../Assets/image3.png";
import Footer from "../../Components/Footers";
import { jwtDecode } from "jwt-decode";


function Rentals() {
  const navigate = useNavigate();


  const baseItems = [
    { img: image1, title: "Wandering Womb", subtitle: "drawing series" },
    { img: image2, title: "Immersive Reading", subtitle: "MU Hybrid Art House" },
    { img: image3, title: "Interactive Installation", subtitle: "Huiden Club" },
  ];

  // const items = Array.from({ length: 9 }).map((_, i) => baseItems[i % baseItems.length]);
   const [searchParams] = useSearchParams();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    if (sessionId) {
      verifyPayment(sessionId);
    } else {
      loadFromToken();
    }
  }, []);

  const verifyPayment = async (sessionId) => {
    const token = localStorage.getItem("mom_token");

    const res = await fetch("/api/verify-payment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify({ session_id: sessionId }),
    });

    const data = await res.json();

    if (data.token) {
      localStorage.setItem("mom_token", data.token);
      loadFromToken(data.token);
    }
  };

  const loadFromToken = (tokenOverride) => {
    const token = tokenOverride || localStorage.getItem("mom_token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      setItems(decoded.purchases || []);
    } catch {
      localStorage.removeItem("mom_token");
    }
  };

  const handleCardClick = (id) => {
    const finalId = id ?? 3;
    navigate(`/descr/${finalId}`);
  };

  return (
    <div className="custom-section">
      <Headers />
      <div className="project-page">
        <h1 className="page-title mt-5 mx-5">MoM Rentals</h1>

        <div className="projects-grid mx-5">
         {items.length === 0 ? (
  <p>No rentals yet.</p>
) : (
  items.map((it) => (
    <div key={it.id} className="project-card"  onClick={() => handleCardClick(it.id)}>
      <div className="project-title">{it.title}</div>
      <div className="project-image-wrap">
                <img src={it.img} alt={it.title} className="project-image" />
              </div>
      <div className="project-subtitle">Access valid for 7 days</div>
    </div>
  ))
)}

        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Rentals;
